/** Les forfaits viennent du même catalogue que le configurateur complet. */
export function quickTourChoices(stage) {
    return (stage?.possibilites || [])
        .filter(p => p.type === 'nb_tour')
        .map(p => ({
            tours: Number(p.valeur),
            price: Number(p.montant_ttc ?? p.price?.best?.montant_ttc ?? p.price?.normal?.montant_ttc ?? NaN),
            possibilite: p,
        }))
        .filter(p => Number.isInteger(p.tours) && p.tours > 0 && Number.isFinite(p.price) && p.price >= 0)
        .sort((a, b) => a.tours - b.tours);
}
